import styled from 'styled-components'

const StyledTableRow = styled.tr``

export default StyledTableRow
